import LandingContainer from "../../Components/Landing";

const Landing = () => {
  return <LandingContainer />;
};

export default Landing;
